import Icon from '@/components/snippets/icon/icon'

export function FilterCollapse({ label, children, activeFilterLabel }) {
  const id = `filter-${label.toLowerCase().replace(/\s/g, '-')}`
  return (
    <x-modal data-id={`filter-${id}`} className="group/filter dropdown-modal flex flex-col border-b border-neutral-light">
      <button
        className="flex items-center justify-between gap-x-0.75 min-h-[56px] px-margin lg:px-1.5 py-1 text-left link-fade"
        data-modal-parent={`filter-${id}`}
        data-modal-role="toggle"
        aria-label={label}
      >
        <div className="flex items-center gap-x-0.5">
          <span className="paragraph-l font-bold">
            {label}
            {typeof activeFilterLabel === 'number' && activeFilterLabel > 0 && (
              <span className="text-neutral-secondary paragraph-b">
                &nbsp;({activeFilterLabel})
              </span>
            )}
          </span>
        </div>
        <div className={'flex w-[14px] h-[8px] group-data-visible/filter:-rotate-180 transition-all children:size-full'}>
          <Icon id="chevron-down" />
        </div>
      </button>
      <div className="dropdown-content">
        <div className="flex flex-col gap-1.5 overflow-hidden">{children}</div>
      </div>
    </x-modal>
  )
}
